import { GreenSystemIcon, RedSystemIcon } from "App/global-style";
import {
  CoverageAccordionHeader,
  CoverageCaption,
  CoverageExplanation,
  CoverageExplanationMarkdown,
  CoverageIcon,
  StyledAccordion,
  StyledAccordionRow,
} from "../coverages.styles";

import { useTexts } from "Components/TextContext";
import {
  Data,
  DittoCoverageMapped,
} from "Components/TextContext/textInterfaces";
import { isComponentWithMarkdown } from "Components/TextContext/utils/dittoCoverageUtils";
import React from "react";
import ReactMarkdown from "react-markdown";

interface Props {
  cardId: string;
  coverages: DittoCoverageMapped[];
  cardIsSelected?: boolean;
  includedCoverages?: boolean;
}

export const DittoCoverageCardAccordion: React.FC<Props> = ({
  cardId,
  coverages,
  cardIsSelected,
  includedCoverages,
}) => {
  const { getText } = useTexts();

  const renderContent = (description: Data): React.ReactNode => {
    return isComponentWithMarkdown(description) ? (
      <CoverageExplanationMarkdown>
        <ReactMarkdown>{getText(description.name)}</ReactMarkdown>
      </CoverageExplanationMarkdown>
    ) : (
      <CoverageExplanation>{description.text}</CoverageExplanation>
    );
  };

  return (
    <StyledAccordion>
      {coverages.map((coverageDetail, index) => {
        const { caption, description } = coverageDetail;
        return (
          <StyledAccordionRow
            id={`${cardId}-${index}-coverage-card-accordion-row`}
            key={index}
            headerProps={{
              type: "button",
            }}
            header={
              <CoverageAccordionHeader selected={cardIsSelected}>
                <CoverageIcon>
                  {includedCoverages && <GreenSystemIcon name="check" />}
                  {!includedCoverages && <RedSystemIcon name="close" />}
                </CoverageIcon>
                <CoverageCaption>{caption.text}</CoverageCaption>
              </CoverageAccordionHeader>
            }
            content={renderContent(description)}
            isSelected={cardIsSelected}
          />
        );
      })}
    </StyledAccordion>
  );
};
